import { abi } from './abi';
import { GOVERNANCE_CONTRACT_ADDRESS } from './constants';
export class Governance {
    constructor(client, { address } = {}) {
        this.getVotingPeriod = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getVotingPeriod'
        });
        this.getVotingQuorumPercent = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getVotingQuorumPercent'
        });
        this.getExecutionDelay = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getExecutionDelay'
        });
        this.getProposalById = ({ id }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getProposalById',
            args: [id]
        });
        this.getProposalTargetContractHash = ({ id }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getProposalTargetContractHash',
            args: [id]
        });
        this.getInProgressProposals = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getInProgressProposals'
        });
        this.getVoteInfoByProposalAndVoter = ({ id, voterAddress }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getVoteInfoByProposalAndVoter',
            args: [id, voterAddress]
        });
        this.getProposalSubmittedEvents = ({ fromBlock = BigInt(0), proposalId, proposer }) => {
            const args = {};
            if (proposalId)
                args._proposalId = proposalId;
            if (proposer)
                args._proposer = proposer;
            return this.client.getContractEvents({
                address: this.address,
                abi,
                eventName: 'ProposalSubmitted',
                fromBlock,
                args
            });
        };
        this.getProposalOutcomeEvaluatedEvents = ({ fromBlock = BigInt(0), proposalId }) => {
            const args = {};
            if (proposalId)
                args._proposalId = proposalId;
            return this.client.getContractEvents({
                address: this.address,
                abi,
                eventName: 'ProposalOutcomeEvaluated',
                fromBlock,
                args
            });
        };
        this.getProposalVoteSubmittedEvents = ({ fromBlock = BigInt(0), proposalId, voter }) => {
            const args = {};
            if (proposalId)
                args._proposalId = proposalId;
            if (voter)
                args._voter = voter;
            return this.client.getContractEvents({
                address: this.address,
                abi,
                eventName: 'ProposalVoteSubmitted',
                fromBlock,
                args
            });
        };
        this.getProposalVoteUpdatedEvents = ({ fromBlock = BigInt(0), proposalId, voter }) => {
            const args = {};
            if (proposalId)
                args._proposalId = proposalId;
            if (voter)
                args._voter = voter;
            return this.client.getContractEvents({
                address: this.address,
                abi,
                eventName: 'ProposalVoteUpdated',
                fromBlock,
                args
            });
        };
        this.client = client;
        this.address = address ?? GOVERNANCE_CONTRACT_ADDRESS;
    }
}
//# sourceMappingURL=governance.js.map